// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React, {useState} from 'react';
import cx from 'classnames';
import get from 'lodash/get';
import {BlockControls} from '../block-controls';

interface NPSBlockFieldProps {
    index?: number;
    fields?: any;
    removeBlock?: any;
    activateBlock?: any;
    input?: any;
}

/* Creates a mock of the widget block for the
 * Net Promoter Score (NPS)® to expose the
 * CXCreationModal data.
 */
export const renderInactiveNPSBlock = (input, npsScores, setNpsScores) => {
    const npsBlock = get(input, ['cx_question_block']);
    const blockClassname = cx('kare-block kare-block--inactive kare-block-nps');
    const setHover = (hasHover, activeHoverIndex) => {
        {
            setNpsScores(
                npsScores.map((el, i) => {
                    return {
                        hoverClassName:
                            i <= activeHoverIndex && hasHover ? 'hover' : '',
                    };
                }),
            );
        }
    };

    // Get the class color depending on the NPS index.
    const getAnswerClass = (i) => {
        return i <= 6 ? 'danger' : i < 9 ? 'warning' : 'success';
    };

    return (
        <section className={blockClassname}>
            <h1>{npsBlock.question}</h1>
            <section className="nps-circle-container">
                <div className="side-bar" />
                {npsScores.map((el, i) => {
                    return (
                        <div key={i} className="nps-circle-wrapper">
                            <div
                                key={i}
                                className={`nps-circle ${
                                    el.hoverClassName
                                } ${getAnswerClass(i)}`}
                                onMouseEnter={() => setHover(true, i)}
                                onMouseLeave={() => setHover(false, i)}
                            >
                                <span>{i}</span>
                            </div>
                        </div>
                    );
                })}
            </section>
            <section className="nps-labels">
                <div className="side-bar" />
                <span className="label negative">
                    0 = {npsBlock.label_negative}
                </span>
                <span className="label positive">
                    10 = {npsBlock.label_positive}
                </span>
            </section>
        </section>
    );
};

export const NPSBlockField = (props: NPSBlockFieldProps) => {
    const {index, fields, removeBlock, activateBlock, input} = props;
    const block = get(input, ['value']);
    const [npsScores, setNpsScores] = useState(
        Array.from({length: 11}).fill({hoverClassName: ''}),
    );
    return (
        <div className="nps kare-cx-block-wrapper">
            {renderInactiveNPSBlock(block, npsScores, setNpsScores)}
            {index >= 0 && fields && removeBlock && (
                <BlockControls
                    index={index}
                    fields={fields}
                    removeBlock={removeBlock}
                    activateBlock={activateBlock}
                />
            )}
        </div>
    );
};
